import React            from 'react';
import PropTypes        from 'prop-types';
import { Link }         from 'react-router-dom';

import Icon             from '../../../../assets/svg/icons.js'

import styles           from '../AccountPage.styl';

function ThanksTab() {
    return  (
        <div
            className = {styles.ThanksTab}
        >
            <div className={styles.wrapper}>
                <div className={styles.content}>
                    <div className={styles.thanksBlock}>
                        <Link
                            to='/'
                            className={styles.cancelLink}
                        >
                            <Icon.Cancel />
                        </Link>
                        <div className={styles.iconWrapper}>
                            <Icon.Done />
                        </div>
                        <div className={styles.title}>
                            Thank you, the registration was successful!
                        </div>
                        <div className={styles.text}>
                            Expect a letter with a link to your service and a password to enter the email you specified, within 20 minutes.
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

ThanksTab.propTypes = {
    onChangeTab : PropTypes.func.isRequired,
    values      : PropTypes.object.isRequired,
    onCreate    : PropTypes.func.isRequired
};

// CongratulationsTab.defaultProps = {
//     onChangeTab : ''
// };

export default ThanksTab;
